var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'JoszakiToast',
    'flex',
    'justify-center',
    'items-center',
    '!px-2',
    'sm:!px-4',
    '!py-1',
    'sm:!py-3',
    'rounded-md',
    'border',
    'shadow-md',
    {
      'text-white': _vm.type !== 'warning',
      'bg-info border-info-darker': _vm.type === 'info',
      'bg-success border-success-darker': _vm.type === 'success',
      'bg-warning text-black border-warning-darker': _vm.type === 'warning',
      'bg-danger border-danger-darker': _vm.type === 'danger',
      'bg-error border-error-darker': _vm.type === 'error',
    },
  ]},[_c('IconComponent',{staticClass:"mr-2 sm:mr-4 !text-base sm:!text-xl min-w-[20px]",attrs:{"icon":_vm.icon}}),_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }